import { ISearchWidget } from 'features/search-widget';

const expediaSearchWidgetConfig: Record<string, ISearchWidget> = {
  'au-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.com.au/_dms/header/logo.svg?siteid=25&locale=en_AU&3ec60977',
        description: 'Expedia.com.au',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.com.au',
      searchParams: {
        siteid: '25',
        langid: '3081',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'd/M/yyyy',
      },
    },
  },

  'ca-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.ca/_dms/header/logo.svg?siteid=4&locale=en_CA&3ec60977',
        description: 'Expedia.ca',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.ca',
      searchParams: {
        siteid: '4',
        langid: '4105',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'dd/MM/yyyy',
      },
    },
  },

  'de-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.de/_dms/header/logo.svg?siteid=6&locale=de_DE&3ec60977',
        description: 'Expedia.de',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.de',
      searchParams: {
        siteid: '6',
        langid: '1031',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'dd.MM.yyyy',
      },
    },
  },

  'fr-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.fr/_dms/header/logo.svg?siteid=20&locale=fr_FR&3ec60977',
        description: 'Expedia.fr',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.fr',
      searchParams: {
        siteid: '20',
        langid: '1036',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'dd/MM/yyyy',
      },
    },
  },

  'hk-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.com.hk/_dms/header/logo.svg?siteid=18&locale=zh_HK&3ec60977',
        description: 'Expedia.com.hk',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.com.hk',
      searchParams: {
        siteid: '18',
        langid: '3076',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'yyyy/M/d',
      },
    },
  },

  'jp-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.co.jp/_dms/header/logo.svg?siteid=28&locale=ja_JP&3ec60977',
        description: 'Expedia.co.jp',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.co.jp',
      searchParams: {
        siteid: '28',
        langid: '1041',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'yyyy/M/d',
      },
    },
  },

  'kr-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.co.kr/_dms/header/logo.svg?siteid=16&locale=ko_KR&3ec60977',
        description: 'Expedia.co.kr',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.co.kr',
      searchParams: {
        siteid: '16',
        langid: '1042',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'yyyy.MM.dd',
      },
    },
  },

  'mx-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.mx/_dms/header/logo.svg?siteid=12&locale=es_MX&3ec60977',
        description: 'Expedia.mx',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.mx',
      searchParams: {
        siteid: '12',
        langid: '2058',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'dd/MM/yyyy',
      },
    },
  },

  'nz-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.co.nz/_dms/header/logo.svg?siteid=29&locale=en_NZ&3ec60977',
        description: 'Expedia.co.nz',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.co.nz',
      searchParams: {
        siteid: '29',
        langid: '3081',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'd/M/yyyy',
      },
    },
  },

  'sg-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.com.sg/_dms/header/logo.svg?siteid=14&locale=en_SG&3ec60977',
        description: 'Expedia.com.sg',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.com.sg',
      searchParams: {
        siteid: '14',
        langid: '2057',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'dd/MM/yyyy',
      },
    },
  },

  'uk-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.co.uk/_dms/header/logo.svg?siteid=3&locale=en_GB&3ec60977',
        description: 'Expedia.co.uk',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.co.uk',
      searchParams: {
        siteid: '3',
        langid: '2057',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'd/M/yyyy',
      },
    },
  },

  'us-expedia': {
    branding: {
      logo: {
        url: 'https://www.expedia.com/_dms/header/logo.svg?siteid=1&locale=en_US&3ec60977',
        description: 'Expedia.com',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.expedia.com',
      searchParams: {
        siteid: '1',
        langid: '1033',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'M/d/yyyy',
      },
    },
  },
};

export { expediaSearchWidgetConfig };
